import { render, staticRenderFns } from "./IncidentsGrid.vue?vue&type=template&id=31c51c1d&"
import script from "./IncidentsGrid.vue?vue&type=script&lang=js&"
export * from "./IncidentsGrid.vue?vue&type=script&lang=js&"
import style0 from "./IncidentsGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports